<div [hidden]="isSafeZoneActive" class="container" style="
    padding: 0;
    width: 410px;
    border-radius: 8px;
    position: fixed;
    left: 0;
    z-index: 1000;
  ">
  <div class="left-panel">
    <div>
      <div class="row header gap-1 d-flex m-0 align-items-center justify-content-between">
        <div class="col-1">
          <img [src]="icon" alt="img/default_entity.png" width="42" height="42" class="entity-window-icon">
        </div>
        <div class="col-7 fs-6">
          <div class="details-name yellow-title">{{ getCurrentIncident()?.name }}</div>
          @if (!isEmpty(getCurrentIncident()?.timestamp)) {
          <div class="details-label">{{
            formatDate(getCurrentIncident()?.timestamp) }}</div>
          }
          @if (showStaticCoordinates()) {
          <div class="details-label">
            Lat: {{ round(this.latitude) }} Lon: {{ round(this.longitude) }}
          </div>
          }
          @if (showTemporalCoordinates()) {
          <div class="details-label">
            Lat: {{ round(tempLat) }} Lon: {{ round(tempLong) }}
          </div>
          }
        </div>
        <div class="col-2 text-end">
          <button class="btn-close btn-close-white" aria-label="Close" (click)="close()"></button>
        </div>
      </div>
      <div class="header">
        <div class="d-flex justify-content-between align-items-center">
          <div class="title">
            {{ "Street View" }}
          </div>
          <div>Incident time: <i>{{ getCurrentIncidentTime() }} @if (enablePlayback) {
              <span> ({{ getElapsedTimePct()
                }}%)</span>
              }</i></div>
        </div>
      </div>

      <div class="sub-header">
        @if ((!this.incident?.isBuildingIncident() || this.incidents?.[0].getStatus())) {
        <div class="jumbotron some-padding-jumbo">
          @if (this.incident?.getStatus()) {
          <div class="row">
            <div class="col-md-2">
              <div class="centering-container">
                <h4 style="display: inline-block;">Status: </h4>
              </div>
            </div>
            @if ((this.incident?.getStatus() === 'active' || this.incidents?.[0].getStatus() === 'active')) {
            <div class="status-fadein status-fadeout col-10">
              <div class="col-md-10">
                <span class="label label-danger"
                  style="padding: 8px 12px; font-size: 14px; display: inline-block; vertical-align: middle; line-height: 1.42857143;">Active</span>
                @if (enableInteraction) {
                <button type="button" class="btn btn-primary" style="float: right;" (click)="resolveEvent()">
                  Resolve
                  <i class="fa fa-thumbs-o-up" style="margin-left: 3px;" aria-hidden="true"></i>
                </button>
                }
              </div>
            </div>
            }
            @if ((this.incident?.getStatus() === 'pending' || this.incidents?.[0].getStatus() === 'pending')) {
            <div class="status-fadein status-fadeout col-10">
              <div class="col-md-10">
                <span class="label label-info"
                  style="padding: 8px 12px; font-size: 14px; display: inline-block; vertical-align: middle; line-height: 1.42857143;">Pending</span>
                <div style="float: right;">
                  <button type="button" class="btn btn-danger" (click)="activateEvent()">
                    Activate
                    <i class="fa fa-bolt" style="margin-left: 3px;" aria-hidden="true"></i>
                  </button>
                  <button type="button" class="btn btn-primary" style="margin-left: 10px;" (click)="closeEvent()">
                    Close
                    <i class="fa fa-times-circle" style="margin-left: 3px;" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
            }
            @if ((this.incident?.getStatus() === 'inactive' || this.incidents?.[0].getStatus() === 'inactive')) {
            <div class="status-fadein status-fadeout col-10">
              <div class="col-md-10">
                <span class="label label-primary"
                  style="padding: 8px 12px; font-size: 14px; display: inline-block; vertical-align: middle; line-height: 1.42857143;">Resolved</span>
              </div>
            </div>
            }
            @if ((this.incident?.getStatus() === 'closed' || this.incidents?.[0].getStatus() === 'closed')) {
            <div class="status-fadein status-fadeout">
              <div class="col-md-10">
                <span class="label label-primary"
                  style="padding: 8px 12px; font-size: 14px; display: inline-block; vertical-align: middle; line-height: 1.42857143;">Closed</span>
              </div>
            </div>
            }
          </div>
          }
          <div class="row">
            <div class="col-md-12">
              @if ((this.incident?.getStatus() === 'inactive' || this.incidents?.[0].getStatus() === 'inactive') ||
              (this.incident?.getStatus() === 'closed' || this.incidents?.[0].getStatus() === 'closed')) {
              <div class="centering-container">
                <div class="centering-container">
                  <h4 style="display: inline-block;">Duration (UTC): </h4>
                  <div style="display:inline-block;"><i>{{ getStartTime() }} to {{ getEndTime() }}</i></div>
                </div>
                <div class="centering-container">
                  <h4 style="display: inline-block;">Total Elapsed Time: </h4>
                  <div style="display:inline-block;"><i>{{ getTotalElapsedTime() }}</i></div>
                </div>
              </div>
              }
              @if ((this.incident?.getStatus() === 'active'|| this.incidents?.[0].getStatus() === 'active')) {
              <div class="centering-container">
                <h4 style="display: inline-block;">Started: {{ getStartTime() }} UTC</h4>
              </div>
              }
            </div>
          </div>
        </div>
        }
      </div>
      <div>
      </div>
      <div class="map-area">
        <app-street-view-map [show3DUserClusters]="data.show3DUserClusters"
          [highGeometryLocation]="highGeometryLocation" [showBeacons]="beaconsVisible" [showCameraLayer]="cameraVisible"
          [currentPage]="data.page" [dangerChecked]="data.dangerChecked" [safeChecked]="data.safeChecked"
          [unknownChecked]="data.unknownChecked" [suspectChecked]="data.suspectChecked"
          (perimeterChange)="perimeterChange($event)" (userOnFloorsChange)="userOnFloorsChange($event)"
          (numberOfBeaconsChange)="numberOfBeaconsChange($event)"
          (numberOfCamerasChange)="numberOfCamerasChange($event)" (cameraLayerChange)="cameraLayerChange($event)"
          (updateChanges)="updateChanges($event)" (collapseChange)="onMapCollapseChange($event)"
          [enablePlaybackChecked]="enablePlayback" [buildingId]="buildingId"></app-street-view-map>
      </div>
      @if (showTabs) {
      <div class="action-buttons nav nav-tabs mb-3">
        <button class="btn btn-outline-primary" [ngClass]="{ active: activeTab === 'description' }"
          (click)="activeTab = 'description'" type="button">
          Description
        </button>
        <button class="btn btn-outline-primary" [ngClass]="{ active: activeTab === 'user' }"
          (click)="activeTab = 'user'" type="button">
          Users
        </button>
        <button class="btn btn-outline-primary" [ngClass]="{ active: activeTab === 'updates' }"
          (click)="activeTab = 'updates'" type="button">
          Updates
        </button>
        <button class="btn btn-outline-primary" [ngClass]="{ active: activeTab === 'safeZones' }"
          (click)="activeTab = 'safeZones'" type="button">
          Safe Zones
        </button>
        <button class="btn btn-outline-primary" [ngClass]="{ active: activeTab === 'sop' }" (click)="activeTab = 'sop'"
          type="button">
          SOP
        </button>
      </div>
      }

      <!-- Tab content -->
      @if (showTabs) {
      <div class="tab-content">
        @if (activeTab === 'user') {
        <div class="tab-pane fade show active">
          <div class="jumbotron no-padding-jumbo px-2" style="margin-top: 10px">
            <div class="filterControlWrap"
              style="display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap;">
              <!-- Total Users -->
              <div
                style="display: flex; align-items: center; gap: 10px; flex-direction: column; align-items: flex-start;">
                <div style="display:flex; align-items:center; gap:10px; font-size: 14px;">
                  <span>Total: {{ data.totalUserCount }}</span>
                  @if (enableInteraction) {
                  <i class="fa fa-envelope icon-size" (click)="sendMessageForFloor()" title="Send message">
                  </i>
                  }
                  @if (enableInteraction) {
                  <i class="fa-solid fa-search icon-size" (click)="toggleSearch()" title="Search users">
                  </i>
                  }
                  <i class="fa-solid fa-earth-asia icon-size" (click)="toggle3DUserClusters()"
                    [style.opacity]="data.show3DUserClusters ? 1 : 0.4" title="Toggle user clusters in 3D">
                  </i>
                </div>
                <!-- Search input shown on new line when toggled -->
                @if (searchVisible) {
                <div style="width:100%; margin-top:6px; margin-bottom: 10px; position: relative;">
                  <input #searchInput type="text" class="form-control form-control-sm"
                    placeholder="Search users by name..." [(ngModel)]="searchQuery"
                    (ngModelChange)="onSearchChange($event)"
                    style="padding-right: 28px; height: 30px; font-size: 13px; border-radius: 6px;" />
                  @if (searchQuery) {
                  <i class="fa fa-times" (click)="clearSearch()" title="Clear search"
                    style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer; color: #888; font-size: 13px;"></i>
                  }
                </div>
                }
              </div>
              <!-- User Status Checkboxes -->
              <div class="user-status-checkboxes" style="display: flex; align-items: center; gap: 10px;">
                <!-- Danger -->
                <label class="status-item">
                  <input type="checkbox" [(ngModel)]="data.dangerChecked" (ngModelChange)="statusChanged()" />
                  <img src="assets/img/arcangel/user_in_danger.svg" style="width: 18px; height: 18px" />
                  {{data.dangerCount}}
                  @if (enableInteraction) {
                  <i class="fa fa-envelope icon-size" (click)="sendMessageToUsers('DANGER')"
                    style="cursor: pointer"></i>
                  }
                </label>
                <!-- Safe -->
                <label class="status-item">
                  <input type="checkbox" [(ngModel)]="data.safeChecked" (ngModelChange)="statusChanged()" />
                  <img src="assets/img/arcangel/user_safe.svg" style="width: 18px; height: 18px" />
                  {{data.safeCount}}
                  @if (enableInteraction) {
                  <i class="fa fa-envelope icon-size" (click)="sendMessageToUsers('SAFE')" style="cursor: pointer"></i>
                  }
                </label>
                <!-- Unknown -->
                <label class="status-item">
                  <input type="checkbox" [(ngModel)]="data.unknownChecked" (ngModelChange)="statusChanged()" />
                  <img src="assets/img/arcangel/user_unknown.svg" style="width: 18px; height: 18px" />
                  {{data.unknownCount}}
                  @if (enableInteraction) {
                  <i class="fa fa-envelope icon-size" (click)="sendMessageToUsers('UNKNOWN')"
                    style="cursor: pointer"></i>
                  }
                </label>
                <!-- Suspect -->
                <label class="status-item d-none">
                  <input type="checkbox" [(ngModel)]="data.suspectChecked" (ngModelChange)="statusChanged()" />
                  <img src="assets/img/arcangel/user_suspect.svg" style="width: 18px; height: 18px" />
                  {{data.suspectCount}}
                  @if (enableInteraction) {
                  <i class="fa fa-envelope icon-size" (click)="sendMessageToUsers('SUSPECT')"
                    style="cursor: pointer"></i>
                  }
                </label>
              </div>
            </div>
            <div style="
                width: 100%;
                height: 1px;
                background-color: #999;
                margin-top: 1px;
                margin-bottom: 5px;
              "></div>
            <div class="filter-result-block">
              Filtered Results: Total {{ data.totalUserCount }} (page
              {{ data.page }} of {{ data.lastPage }})
            </div>
            <div class="tableScroll">
              <table style="width: 100%; background-color: rgba(0, 0, 0, 0)">
                <tr>
                  <td style="width: 33%; vertical-align: top">
                    @for (user of data.userList1; track user) {
                    <div style="padding: 0px">
                      {{ user.name }}
                      <img [src]="user.src" style="width: 12px; height: 12px" />
                      @if (user.visible) {
                      <img src="assets/img/eyeVisible.svg" (click)="toggleUserVisibility(user)"
                        style="width: 20px; height: 20px; margin-left: 5px" />
                      }
                      @if (!user.visible) {
                      <img src="assets/img/eyeHidden.svg" (click)="toggleUserVisibility(user)"
                        style="width: 20px; height: 20px; margin-left: 5px" />
                      }
                      @if (user.visible && user.status !== 'SUSPECT') {
                      <i class="fa fa-info-circle" (click)="showUserInfo(user)"
                        style="margin-left: 5px; padding-top: 5px"></i>
                      }
                      @if (user.visible && user.status === 'SUSPECT') {
                      <i class="fa fa-info-circle" (click)="showUserInfo(user)"
                        style="margin-left: 5px; padding-top: 5px"></i>
                      }
                    </div>
                    }
                  </td>
                  <td style="width: 33%; vertical-align: top">
                    @for (user of data.userList2; track user) {
                    <div>
                      {{ user.name }}
                      <img [src]="user.src" style="width: 12px; height: 12px" />
                      @if (user.visible) {
                      <img src="assets/img/eyeVisible.svg" (click)="toggleUserVisibility(user)"
                        style="width: 20px; height: 20px; margin-left: 5px" />
                      }
                      @if (!user.visible) {
                      <img src="assets/img/eyeHidden.svg" (click)="toggleUserVisibility(user)"
                        style="width: 20px; height: 20px; margin-left: 5px" />
                      }
                      @if (user.visible && user.status !== 'SUSPECT') {
                      <i class="fa fa-info-circle" (click)="showUserInfo(user)"
                        style="margin-left: 5px; padding-top: 5px"></i>
                      }
                      @if (user.visible && user.status === 'SUSPECT') {
                      <i class="fa fa-info-circle" (click)="showUserInfo(user)"
                        style="margin-left: 5px; padding-top: 5px"></i>
                      }
                    </div>
                    }
                  </td>
                  <td style="width: 34%; vertical-align: top">
                    @for (user of data.userList3; track user) {
                    <div>
                      {{ user.name }}
                      <img [src]="user.src" style="width: 12px; height: 12px" />
                      @if (user.visible) {
                      <img src="assets/img/eyeVisible.svg" (click)="toggleUserVisibility(user)"
                        style="width: 20px; height: 20px; margin-left: 5px" />
                      }
                      @if (!user.visible) {
                      <img src="assets/img/eyeHidden.svg" (click)="toggleUserVisibility(user)"
                        style="width: 20px; height: 20px; margin-left: 5px" />
                      }
                      @if (user.visible && user.status !== 'SUSPECT') {
                      <i class="fa fa-info-circle" (click)="showUserInfo(user)"
                        style="margin-left: 5px; padding-top: 5px"></i>
                      }
                      @if (user.visible && user.status === 'SUSPECT') {
                      <i class="fa fa-info-circle" (click)="showUserInfo(user)"
                        style="margin-left: 5px; padding-top: 5px"></i>
                      }
                    </div>
                    }
                  </td>
                </tr>
              </table>
            </div>
            <span style="float: right; margin-right: 10px; margin-top: 10px">
              @if (data.page > 1) {
              <span (click)="jumpPage(-1)" style="cursor: pointer">
                <i class="fa fa-chevron-left"></i>Previous
              </span>
              }
              <span style="margin-left: 30px"> Page {{ data.page }} </span>
              @if (data.page < data.lastPage) { <span (click)="jumpPage(1)" style="margin-left: 30px; cursor: pointer">
                Next <i class="fa fa-chevron-right"></i>
            </span>
            }
            </span>
          </div>
        </div>
        }
        @if (activeTab === 'perimeters') {
        <div class="tab-pane custom-scroll fade show active">
          <!-- Perimeters tab content here -->
          @for (perimeter of perimeters; track perimeter) {
          <div>
            <div class="floor-summary">
              <div class="floor-row">
                <div class="floor-label">{{ perimeter.name }}</div>
                <div class="color-boxes">
                  <div class="color-box danger-incident">0</div>
                  <div class="color-box safe-incident">0</div>
                  <div class="color-box unknown-incident">0</div>
                  <div class="color-box first-response">0</div>
                  <div class="color-box suspect-incident">0</div>
                </div>
              </div>
            </div>
          </div>
          }
        </div>
        }
        @if (activeTab === 'cameras') {
        <div class="tab-pane fade show active">
          <!-- Cameras tab content here -->
          <table class="camera-table">
            <thead>
              <tr>
                <th>Camera Name</th>
                <th>Room</th>
              </tr>
            </thead>
            <tbody>
              @for (camera of cameraListForFloor; track camera.id) {
              <tr>
                <td>{{ camera.label }}</td>
                <td>{{ camera.room.label }}</td>
                <td class="actions">
                  <button type="button" class="btn btn-icon" (click)="viewInfo(camera)" title="Info">
                    <i class="fas fa-info"></i>
                  </button>
                  <button type="button" class="btn btn-icon" (click)="viewCamera(camera)" title="Play">
                    <i class="fas fa-play"></i>
                  </button>
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
        }
        @if (activeTab === 'description') {
        <div class="tab-pane fade show active">
          <div class="p-3">
            <p>
              {{ mapentityid?.incidents?.[0]?.description || mapentityid?.description ||'No description available.' }}
            </p>
          </div>
        </div>
        }
        <!-- UPDATES TAB -->
        @if (activeTab === 'updates') {
        <div class="tab-pane fade show active">
          <div class="panel panel-warning m-2">
            <!-- Header Row -->
            <div class="row pt-1 fs-6 mb-1 align-items-center">
              <!-- Show/Hide and Arrow -->
              <div class="col-md-3">
                <div class="centering-container d-flex align-items-center">
                  <!-- Visibility Toggle -->
                  <div class="me-1" [ngClass]="areUpdatesVisible() ? 'visible-item' : 'hidden-item'"
                    matTooltip="Show/Hide" (click)="showHideAllUpdates()">
                  </div>
                  <!-- Up/Down Arrow -->
                  @if (this.updates?.length > 0) {
                  <div class="d-inline-block ms-2">
                    <i class="fa" [ngClass]="showUpdates ? 'fa-caret-down' : 'fa-caret-right'"
                      (click)="toggleUpdates()"></i>
                  </div>
                  }
                </div>
              </div>
              <!-- Title -->
              <div class="col-md-4 centering-text">Updates</div>
              <!-- Count -->
              <div class="col-md-3 centering-text">({{ updates?.length || 0 }})</div>
              <!-- Add Update Button -->
              <div class="col-md-2 text-end">
                @if (enableInteraction) {
                <img src="assets/img/arcangel/add_update.svg" alt="Add Update" width="20" height="20"
                  matTooltip="Add Update" style="cursor: pointer" (click)="addUpdate()">
                }
              </div>
            </div>
            <!-- Updates List -->
            @if (showUpdates) {
            <div>
              <table class="table custom-table bg-none">
                <thead>
                  <tr class="fs-6 fw-bold" style="border-bottom: 1px solid #666;">
                    <th></th>
                    <th>Sender</th>
                    <th>Time</th>
                    <th>Title</th>
                  </tr>
                </thead>
                <tbody>
                  @for (update of updates; track update) {
                  <tr>
                    <td>
                      <div class="d-inline-block me-2"
                        [ngClass]="update?.cesiumEntity?.show ? 'visible-item' : 'hidden-item'" matTooltip="Show/Hide"
                        (click)="showHideEntity(update)">
                      </div>
                      <img [src]="update?.icon" (click)="openEntity(update)" class="update-icon cursor-pointer"
                        title="Show details">
                    </td>
                    <td>{{ update?.data?.userInfo?.name }}</td>
                    <td>{{ update?.localTime }}</td>
                    <td>{{ update?.name }}</td>
                  </tr>
                  }
                </tbody>
              </table>
            </div>
            }
          </div>
        </div>
        }
        @if (activeTab === 'safeZones') {
        <div class="tab-pane fade show active">
          <div class="panel panel-warning m-2">
            <div class="row pt-1">
              <!-- Show/Hide All Safezones -->
              <div class="col-md-3 centering-container">
                <div class="me-1" [ngClass]="!areSafezonesVisible() ? 'visible-item' : 'hidden-item'" title="Show/Hide"
                  (click)="showHideAllSafezones()"></div>
                <!-- Up/Down Arrow -->
                @if (safezones.length > 0) {
                <div class="d-inline-block ms-2">
                  <i class="fa" [ngClass]="!showSafeZones ? 'fa-caret-down' : 'fa-caret-right'"
                    (click)="toggleSafeZones()"></i>
                </div>
                }
              </div>
              <!-- Title and Count -->
              <div class="col-md-4 centering-text">Safe Zones</div>
              <div class="col-md-3 centering-text">({{ safezones.length }})</div>
              <div class="col-md-2">
                @if (enableInteraction) {
                <img src="assets/img/arcangel/add_update.svg" matTooltip="Add Safe Zone" width="20" height="20"
                  (click)="addSafeZone()">
                }
              </div>
            </div>
            <!-- SafeZone List -->
            @if (!showSafeZones) {
            <div class="">
              @for (safezone of safezones; track safezone) {
              <div class="row pt-1 px-2 safezone-row align-items-center">
                <div class="col-md-12 d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center flex-grow-1 overflow-hidden" (click)="goToEntity(safezone)">
                    <div class="me-1" [ngClass]="!isSafezoneVisible(safezone) ? 'visible-item' : 'hidden-item'"
                      title="Show/Hide" (click)="$event.stopPropagation(); showHideEntity(safezone)"></div>
                    <div class="safezone-item me-1"></div>
                    <div class="centering-text text-truncate cursor-pointer" [title]="safezone?.name">
                      {{ safezone?.name }}
                    </div>
                  </div>
                  @if (!isPerimeterSafezone(safezone)) {
                  <button type="button" class="btn-sm text-danger p-0 ms-2 delete-safezone-btn" title="Delete Safe Zone"
                    (click)="deleteSafezone(safezone, $event)">
                    <i class="fa fa-trash"></i>
                  </button>
                  }
                </div>
              </div>
              }
            </div>
            }
          </div>
        </div>
        }
        @if (activeTab === 'sop') {
        <div class="tab-pane fade show active">
          <div style="margin-left: 20px">
            <div>
              SOP:
              {{ sopInfo.sopTask.label }}
              ({{ sopInfo.sopTask.type }}):
              {{ sopInfo.sopTask.stepsCompleted }}/{{ sopInfo.sopTask.totalNumberOfSteps }}
            </div>
            <table style="width: 100%">
              <tr style="border-bottom: solid 1px #666">
                <td>#</td>
                <td>SOP Step</td>
                <td>Info</td>
                <td>Time</td>
                <td>Completed</td>
              </tr>
              @for (step of sopInfo.sopTaskStep; let i = $index; track step) {
              <tr>
                <td>{{ step.order }}</td>
                <td>{{ step.label | slice: 0:25 }}</td>
                <td>
                  <i class="fa fa-info" style="cursor: pointer" title="Show details"
                    (click)="viewTaskStepInfo(step)"></i>
                </td>
                <td>{{ step.estimatedTime }}</td>
                <td>
                  <!-- Editable Mode -->
                  @if (enableInteraction) {
                  <input type="checkbox" [checked]="step.isCompleted === 'Yes'" (click)="
                        step.isCompleted === 'Yes'
                          ? markTaskStepAsUncompleted(step.id)
                          : markTaskStepAsCompleted(step.id)
                      " [title]="
                        step.isCompleted === 'Yes'
                          ? 'Click to mark as uncompleted'
                          : 'Click to mark as completed'
                      " />
                  } @else {
                  @if (step?.isCompleted === 'Yes') {
                  <span>Yes</span>
                  }
                  @if (step?.isCompleted === 'No') {
                  <span>No</span>
                  }
                  }
                  <!-- Read-only Mode -->
                </td>
              </tr>
              }
            </table>
          </div>
        </div>
        }
      </div>
      }
    </div>
    <div>
      <div class="icon-bar">
        <div class="footer-icon-row gap-5">
          @for (command of commands; track command; let i = $index) {
          <img [src]="command.icon" alt="Command icon" class="footer-icon" (click)="onCommandClick(i,liveData)" />
          }
        </div>
      </div>
    </div>
  </div>
</div>
@if (showGlobeClick) {
<div
  class="location-palette-container globe-click-modal modal-bottom d-flex align-items-center justify-content-between">
  <div class="d-flex">
    <div class="m-3 text-white">Click anywhere on the globe to create an incident update.</div>
    <button type="button" class="close-button" aria-label="Close" (click)="onGlobeClickClose()">×</button>
  </div>
</div>
}